<template>
  <div class="row">
    <div class="col-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateDisease"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @fillDiseaseForm="fillDiseaseForm"
              @showHideLoading="showHideLoading"
              @getNameDiseaseDigit="getNameDiseaseDigit"
              @setFileFao="setFileFao"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('diseases.plague_or_disease_type')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @fillDiseaseForm="fillDiseaseForm"
              @showHideLoading="showHideLoading"
              @getNameDiseaseDigit="getNameDiseaseDigit"
              @setImgsToMove="setImgsToMove"
              @emitDelete="emitDelete"
            ></second-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.associations')"
            :before-change="() => validateStep('thirdStep')"
          >
            <third-step
              ref="thirdStep"
              @fillDiseaseForm="fillDiseaseForm"
              @showHideLoading="showHideLoading"
            ></third-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              4.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td
                        :style="'background-color: ' + diseaseForm.color"
                        scope="row"
                      >
                        <h6>
                          <strong>{{ $t('common_words.color') }}:</strong>
                        </h6>
                        {{ diseaseForm.color }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ diseaseForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('diseases.scientific_name') }}:</strong>
                        </h6>
                        {{ diseaseForm.scientific_name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{
                            $t('diseases.plague_or_disease_questionmark')
                          }}</strong>
                        </h6>
                        {{
                          diseaseForm.type_p_e == 1
                            ? 'Plaga'
                            : diseaseForm.type_p_e == 2
                            ? 'Enfermedad'
                            : null
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.observation') }}</strong>
                        </h6>
                        {{ diseaseForm.observation }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.type') }}:</strong>
                        </h6>
                        {{
                          diseaseForm.catch_type == 1
                            ? $t('common_words.level_or_status')
                            : $t('common_words.normal')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm" v-if="diseaseForm.catch_type == 1">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.level_or_status') }}:</strong
                          >
                        </h6>
                        <el-tag type="info"
                          >{{ diseaseForm.init_level }} -
                          {{ diseaseForm.init_name_lavel }}</el-tag
                        >
                        <span
                          v-for="(name, index) in diseaseForm.name_level"
                          :key="index"
                        >
                          <el-tag type="info"
                            >{{ diseaseForm.number_level[index] }} -
                            {{ name }}</el-tag
                          >
                          <br v-if="index % 5 == 0 && index != 0" />
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{
                            $t('common_words.photograph_questionmark')
                          }}</strong>
                        </h6>
                        {{
                          diseaseForm.photo
                            ? $t('common_words.yes')
                            : $t('common_words.no')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.perimeter') }}?</strong>
                        </h6>
                        {{
                          diseaseForm.perimeter
                            ? $t('common_words.yes')
                            : $t('common_words.no')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(
                            business, index
                          ) in diseaseForm.business_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                          <br v-if="index % 5 == 0 && index != 0" />
                        </span>
                        <el-tag
                          type="warning"
                          v-if="diseaseForm.business_names.length == 0"
                          >{{
                            $t('common_words.no_associated_companies')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.associated_crops') }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(crop, index) in diseaseForm.crop_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ crop }}</el-tag>
                          <br v-if="index % 5 == 0 && index != 0" />
                        </span>
                        <el-tag
                          type="warning"
                          v-if="diseaseForm.crop_names.length == 0"
                          >{{ $t('common_words.no_associated_crops') }}</el-tag
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import { convertFirstLetterUppercase } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import ThirdStep from './steps/ThirdStep.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import { showContinue } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from '../../../../i18n';

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
  },

  data() {
    return {
      title: '',
      diseaseForm: {
        name: null,
        observation: null,
        catch_type: null,
        crop_ids: [],
        business_ids: [],
        business_names: [],
        crop_names: [],
        type_p_e_name: null,
      },
      wizardModel: {},
      fileToMove: null,
      imgsToMove: [],
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinMenu],

  computed: {
    getWithoutTranslate() {
      return i18n.t('common_words.without');
    },
  },

  watch: {
    '$i18n.locale': 'getNameDiseaseDigit',
  },

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        id: null,
        name: null,
        observation: null,
        photo: false,
        perimeter: false,
        confirmation: false,
        color: null,
        scientific_name: null,
        type_p_e: null,
        type_p_e_name: null,
        fileList: [],
      };
      this.$refs.secondStep.model = {
        id: null,
        catch_type: null,
        level_number: null,
        init_level: 0,
        init_name_lavel: i18n.t('diseases.disease_no_appearance'),
        number_level: [],
        name_level: [],
        disabled: [],
        fileList: [],
        symptom_names: [],
        symptom_ids: [],
        symptoms_number: null,
      };
      this.$refs.thirdStep.model = {
        business_ids: [],
        crop_ids: [],
      };
      this.diseaseForm = {
        name: null,
        observation: null,
        catch_type: null,
        crop_ids: [],
        business_ids: [],
        business_names: [],
        crop_names: [],
        type_p_e_name: null,
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    fillDiseaseForm(ref, others) {
      this.diseaseForm = Object.assign(
        {},
        this.diseaseForm,
        this.$refs[ref].model
      );

      if (others)
        this.diseaseForm = Object.assign({}, this.diseaseForm, others);
    },

    setFileFao(nameFile) {
      this.fileToMove = nameFile;
    },

    setImgsToMove(nameImg) {
      this.imgsToMove.push(nameImg);
    },

    emitDelete(nameImg) {
      this.imgsToMove = this.imgsToMove.filter((img) => {
        img != nameImg;
      });
    },

    storeUpdateDisease() {
      this.showHideLoading(true);
      this.diseaseForm.route = 'diseases/diseases';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.diseaseForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.diseaseForm)
            .then((response) => {
              this.showHideLoading();
              Axios.postMasters({
                route: 'diseases/diseases/movediseasefile',
                user: this.$store.state.auth.user.id,
                disease_id: response.data.data.id,
                fileToMove: this.fileToMove,
              });
              Axios.postMasters({
                route: 'diseases/diseases/movediseaselevelimage',
                user: this.$store.state.auth.user.id,
                disease_id: response.data.data.id,
                imgsToMove: this.imgsToMove,
                disease_statuses:
                  response.data.data.disease_statuses.length > 0
                    ? response.data.data.disease_statuses.map((st) => st.id)
                    : [],
              });
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/diseases/diseases',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.diseaseForm)
            .then((response) => {
              this.showHideLoading();
              Axios.postMasters({
                route: 'diseases/diseases/movediseasefile',
                user: this.$store.state.auth.user.id,
                disease_id: response.data.data.id,
                fileToMove: this.fileToMove,
              });
              Axios.postMasters({
                route: 'diseases/diseases/movediseaselevelimage',
                user: this.$store.state.auth.user.id,
                disease_id: response.data.data.id,
                imgsToMove: this.imgsToMove,
                disease_statuses:
                  response.data.data.disease_statuses.length > 0
                    ? response.data.data.disease_statuses.map((st) => st.id)
                    : [],
              });

              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/diseases/diseases',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    getNameDiseaseDigit() {
      const name = this.$refs['firstStep'].model.name;
      const nameUpper = convertFirstLetterUppercase(name);
      this.$refs[
        'secondStep'
      ].model.init_name_lavel = `${this.getWithoutTranslate} ${nameUpper}`;
    },
  },

  mounted() {
    this.selectedItemOnMenu('diseases/diseases');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('diseases/diseases');
  },
};
</script>
<style></style>
